<script lang="ts">
  import ToggleButton from '$shared/atoms/ToggleButton/ToggleButton.svelte';
  import {
    ToggleBackgroundColor,
    ToggleButtonSize
  } from '$shared/atoms/ToggleButton/ToggleButtonProps';

  interface Props {
    disabled?: boolean;
    checked?: boolean;
    name: string;
    actionLabel: string;
    onchange?: (e: Event) => void;
  }

  let {
    disabled = false,
    checked = false,
    name,
    actionLabel,
    onchange
  }: Props = $props();
</script>

<div class="comp-toggle-action-label">
  <div data-cy="toggle-label" class="action-label">{actionLabel}</div>
  <div class="toggle">
    <ToggleButton
      {disabled}
      {checked}
      options={{
        name,
        size: ToggleButtonSize.Large,
        inactiveColor: ToggleBackgroundColor.Red
      }}
      {onchange}
    />
  </div>
</div>

<style>
  .comp-toggle-action-label {
    display: flex;
    align-items: center;
  }
  .comp-toggle-action-label .action-label {
    margin-right: 12px;
    font-size: 11px;
    color: var(--grey-dark);
  }
</style>
